import React from "react";
import { Link } from "react-router-dom";

export default function TagSection() {
	return (
		<div className="fugu--tags fugu--tags2">
			<h4>Tags:</h4>
			<ul>
				<li>
					<Link to={"#"}> NFTs art </Link>
				</li>
				<li>
					<Link to={"#"}> Cryptocurrency </Link>
				</li>
				<li>
					<Link to={"#"}> Digital </Link>
				</li>
				<li>
					<Link to={"#"}> Creative works </Link>
				</li>
			</ul>
		</div>
	);
}
